import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap'
import { I18nModule, provideConfig } from '@spartacus/core'
import { OutletModule, PageComponentModule } from '@spartacus/storefront'
import { EbBackToTopButtonModule } from './back-to-top-button/eb-back-to-top-button.module'
import { EbBannerModule } from './banner/eb-banner.module'
import { EbCheckoutStepButtonsModule } from './checkout-step-buttons/eb-checkout-step-buttons.module'
import { EbButtonModule } from './cms-button/eb-button.module'
import { EbDatePickerI18nService } from './date-picker/eb-date-picker-i18n.service'
import { EbDropdownModule } from './dropdown/eb-dropdown.module'
import { EbMatomoModule } from './eb-matomo/eb-matomo.module'
import { EBResponsiveBannerModule } from './eb-reponsive-banner/eb-responsive-banner.module'
import { EBResponsiveHighlightModule } from "./eb-responsive-highlight/eb-responsive-highlight.module";
import { EbTabParagraphContainerComponent } from './eb-tab-paragraph-container/eb-tab-paragraph-container.component'
import { EbGenericPageStepperModule } from './generic-page-stepper/eb-generic-page-stepper.module'
import { EbGenericScrollModule } from './generic-scroll/eb-generic-scroll.module'
import { EbGroupedFavoritesModule } from './grouped-favorites/eb-grouped-favorites.module'
import { EbIconModule } from './icons/eb-icon.module'
import { EbInfoBoxModule } from './info-box/eb-info-box.module'
import { EbLoadMoreButtonModule } from './load-more-button/eb-load-more-button.module'
import { EbNoSalesAreaMessageModule } from './no-sales-area-message/eb-no-sales-area-message.module'
import { EbParagraphModule } from './paragraph/eb-paragraph.module'
import { EbSpinnerModule } from './spinner/eb-spinner.module'
import { EbStorefrontModule } from './storefront/eb-storefront.module'
import { EbSuccessorModule } from './successor/eb-successor.module'
import { EbUnitSelectorComponent } from './unit-selector/eb-unit-selector.component'

@NgModule({
  imports: [
    CommonModule,
    EbStorefrontModule,
    EbSpinnerModule,
    EbGenericScrollModule,
    EbInfoBoxModule,
    EbIconModule,
    EbGenericPageStepperModule,
    EbCheckoutStepButtonsModule,
    EbSuccessorModule,
    EbBannerModule,
    EbParagraphModule,
    EbLoadMoreButtonModule,
    EbDropdownModule,
    EbGroupedFavoritesModule,
    EbNoSalesAreaMessageModule,
    EbButtonModule,
    EbBackToTopButtonModule,
    PageComponentModule,
    OutletModule,
    I18nModule,
    EbMatomoModule,
    MatSlideToggleModule,
    MatFormFieldModule,
    BrowserAnimationsModule,
    EBResponsiveBannerModule,
    EBResponsiveHighlightModule
  ],
  declarations: [EbTabParagraphContainerComponent,EbUnitSelectorComponent],
  exports: [EbTabParagraphContainerComponent,EbUnitSelectorComponent],
  providers: [
    EbDatePickerI18nService,
    provideConfig({
      cmsComponents: {
        CMSTabParagraphContainer: {
          component: EbTabParagraphContainerComponent
        },
        EbUnitSelectorComponent: {
          component: EbUnitSelectorComponent,
        }
      },
    }),
    {
      provide: NgbDatepickerI18n,
      useClass: EbDatePickerI18nService
    }
  ]
})
export class EbComponentsModule {}
